import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { atlImageSliderSwiperOptions, getSwiperInstanceFromElementRef } from '@atlas-workspace/shared/directives';
import { ImageModel } from '@atlas-workspace/shared/models';
import { cloneDeep } from 'lodash';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Swiper, SwiperOptions } from 'swiper/types';

@Component({
  selector: 'atl-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageSliderComponent implements OnChanges {
  public swiperconfig: SwiperOptions = cloneDeep(atlImageSliderSwiperOptions);
  @Input() readonly displayW500Image = false;
  @Input() images!: ImageModel[];
  @Input() set config(_config: SwiperOptions) {
    this.swiperconfig = {
      ..._config,
      navigation: this.images.length > 1,
      ...(_config.pagination && this.images.length < 2 && {
        pagination: false,
      }),
    };
  }
  @Input() set activeIndex(index: number | undefined) {
    Number.isInteger(index) && this.slideTo(<number>index);
  }

  @Output() private readonly openPreview = new EventEmitter<number>();
  @Output() public readonly afterInitSwiper = new EventEmitter<Swiper>();

  @ViewChild('swiper') swiperEl!: ElementRef;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeIndex) return;
    of(true)
      .pipe(delay(0))
      .subscribe(() => {
        this.slideTo(0);
      });
  }

  getImageUrl(slide: Partial<ImageModel | any>): string {
    const noImagePlaceholder = 'assets/no_images.png';
    if (!slide || !slide.fileName) return noImagePlaceholder;
  
    const fileName = slide.fileName;
  
    const versions = fileName?.versions || fileName?.fileName?.versions;
    const url = fileName?.url || fileName?.fileName?.url;
  
    if (this.displayW500Image) {
      return versions?.w500?.url || url || noImagePlaceholder;
    }
  
    return url || versions?.w500?.url || noImagePlaceholder;
  }

  private slideTo(index: number): void {
    const swiper = getSwiperInstanceFromElementRef(this.swiperEl);
    if (swiper) {
      swiper.params.loop
        ? swiper.slideToLoop(index, 0, false)
        : swiper.slideTo(index);
      swiper.update();
    }
  }

  public get swiperInstance(): Swiper | undefined {
    return getSwiperInstanceFromElementRef(this.swiperEl);
  }

  emitPreview(i: number): void {
    this.openPreview.emit(i);
  }

  trackBy: (i: number, item: any) => number = (i: number, item: any): number => item.id;

  get multiple() : boolean {
    return this.images.length > 1;
  }
}
